// RC8 · Long-form briefing link safety (PO 2026-09-21).
//
// Pure, dependency-free helpers used by the long-form Markdown reader.
// Kept separate from the renderer so the security-relevant logic can be
// unit-tested deterministically without importing the (ESM) Markdown
// library. Defence-in-depth: react-markdown already drops raw HTML and
// sanitises URLs, these helpers add an explicit second layer.

const SAFE_ABSOLUTE = /^(https?:|mailto:|tel:)/i;
const DANGEROUS = /^(javascript|data|vbscript|file):/i;

// Return a safe href, or null when the URL must be dropped entirely.
// Accepts http(s)/mailto/tel absolute URLs, and in-page/relative links
// (anchors, `/path`, `./path`, `../path`). Everything else — notably
// javascript:, data:, vbscript:, file: — is rejected.
export function safeHref(href) {
  if (!href || typeof href !== "string") return null;
  const trimmed = href.trim();
  if (!trimmed) return null;
  // Strip control chars that can be used to smuggle a scheme.
  const cleaned = trimmed.replace(/[\u0000-\u001F\u007F]/g, "");
  if (DANGEROUS.test(cleaned)) return null;
  if (SAFE_ABSOLUTE.test(cleaned)) return cleaned;
  // Relative / anchor links are safe (no scheme).
  if (/^(#|\/|\.\/|\.\.\/)/.test(cleaned)) return cleaned;
  // A bare scheme-like prefix we don't recognise → reject.
  if (/^[a-z][a-z0-9+.-]*:/i.test(cleaned)) return null;
  // Scheme-less token (e.g. "example.com/x") — treat as relative-safe.
  return cleaned;
}

// Anchor attributes. Absolute http(s) links open in a new tab with
// hardened rel; relative/anchor links stay in-app with no target.
export function externalLinkProps(href) {
  if (href && /^https?:/i.test(href)) {
    return { target: "_blank", rel: "noopener noreferrer nofollow" };
  }
  return {};
}
